import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Modal from '../../../shared/Modal/Modal.jsx';
import LanguageModal from '../../../shared/ModalComponents/LanguageModal.jsx';
import defaultAttrs from '../../../lib/utils/defaultAttrs';

const openModalConfirmation = () => {
  Modal({
    component: <LanguageModal />,
    width: '620px',
    padding: '17px',
  });
};

const LanguageButton = ({ showLanguagePrompt }) => {
  const { t } = useTranslation('header');

  return (
    <IconWrapper
      type="button"
      aria-label={t('headerButtons.language')}
      aria-haspopup="dialog"
      onClick={() => openModalConfirmation()}
    >
      <LanguageIcon
        $showLanguagePrompt={showLanguagePrompt}
        aria-hidden="true"
      />
    </IconWrapper>
  );
};

export default LanguageButton;

const LanguageIcon = styled.i.attrs(
  defaultAttrs({
    className: 'fa-regular fa-language fa-2x',
  }),
)`
  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    &:hover {
      color: ${themeGet('colors.black.60')};
    }
  }

  ${({ $showLanguagePrompt }) =>
    $showLanguagePrompt &&
    css`
      color: ${themeGet('colors.primary.100')};

      &:hover {
        color: ${themeGet('colors.primary.120')};
      }
    `}
`;

const IconWrapper = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid ${themeGet('colors.primary.100')};
    outline-offset: 4px;
    border-radius: 4px;
  }
  ${themeGet('mediaQueries.forMediumUp')} {
    flex: 0;
    display: block;
    cursor: pointer;
    margin: 0px -10px 0px 20px;
  }
`;
